import React from "react";
import Titles from "../layouts/Titles";
import ContactLeft from "./ContactLeft";
import ContactRight from "./ContactRight";

const Contact = () => {
  return (
    <section
      id="contacts"
      className="w-full py-20  border-b-[1px] border-b-black"
    >
      <div className="flex justify-center items-center text-center">
        <Titles title="Contact" des="Contact With Me" />
      </div>
      <div className="w-full">
        <div className="w-full h-auto flex flex-col lgl:flex-row justify-between">
          <ContactLeft />
          <ContactRight />
        </div>
      </div>
    </section>
  );
};

export default Contact;
